$(document).ready(function () {
  // ANIMAÇÃO LISTA CATEGORIA

  $(".lista-categoria").on("click mouseenter", function (e) {
    exibeSubcategoria($(this).find("i"), e.type);
  });

  function exibeSubcategoria(element, event) {
    const listaCategoria = element.parent().parent();

    if (event == "click") {
      if ($(".sublista-categoria", listaCategoria).is(":hidden")) {
        element.toggleClass("gira-1").removeClass("gira-2");
        $(".sublista-categoria", listaCategoria).slideDown();
      } else {
        element.toggleClass("gira-2").removeClass("gira-1");
        $(".sublista-categoria", listaCategoria).slideUp();
      }
    } else if (event == "mouseenter") {
      if ($(".sublista-categoria", listaCategoria).is(":hidden")) {
        element.toggleClass("gira-1").removeClass("gira-2");
        $(".sublista-categoria", listaCategoria).slideDown();
      }
    }
  }
});
